import { motion } from 'framer-motion';

export function TableSkeleton() {
    return (
        <div className="p-6 max-w-[1600px] mx-auto h-full flex flex-col overflow-hidden animate-pulse">
            {/* Header Skeleton */}
            <div className="flex justify-between items-center mb-6 shrink-0">
                <div className="space-y-2">
                    <div className="h-8 w-48 bg-muted rounded-lg" />
                    <div className="h-4 w-64 bg-muted/50 rounded-lg" />
                </div>
            </div>

            {/* Toolbar Skeleton */}
            <div className="flex gap-4 mb-6 shrink-0">
                <div className="h-10 w-96 bg-muted rounded-lg" />
            </div>

            {/* Table Skeleton */}
            <div className="flex-1 rounded-xl border border-border bg-card/50 overflow-hidden">
                <div className="h-12 bg-muted/50 border-b border-border mb-4" />
                {[1, 2, 3, 4, 5].map((i) => (
                    <div key={i} className="flex items-center gap-4 px-4 py-4 border-b border-border/50">
                        <div className="h-4 w-1/4 bg-muted/50 rounded" />
                        <div className="h-4 w-1/4 bg-muted/50 rounded" />
                        <div className="h-4 w-1/4 bg-muted/50 rounded" />
                        <div className="h-4 w-1/4 bg-muted/50 rounded" />
                    </div>
                ))}
            </div>
        </div>
    );
}
